<template>
  <v-container fluid>
    <v-row>
      <v-col md="12">
        <v-card flat>
          <v-skeleton-loader v-if="loading && isTabletOrDesktop" type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :options.sync="options"
            :server-items-length="serverItemsLength"
            v-show="!loading"
            :items="courses"
            item-key="id"
          >
          <template class="d-flex-inline" v-slot:item.name="{ item }">
                <div class="sm-inline-flex text-center">
                  <table-thumb :thumb="item"></table-thumb>
                  <span class="three-dots ml-2 mt-auto mb-auto">{{
                    item.name
                  }}</span>
                </div>
              </template>
            <template v-slot:item.published="{ item }">
              <v-icon v-if="item.published" color="green" small
                >fa-check</v-icon
              >
              <v-icon v-else color="red" small>fa-times</v-icon>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import courseAPI from '@/api/course.js';
import testAPI from '@/api/test.js';
import TableThumb from '@/components/admin/course/TableThumb';
import EditCourse from '@/components/admin/course/Edit';
import CreateCourse from '@/components/admin/course/Create';
import EnrolUsers from '@/components/admin/course/Enrol';
import ManageDeadlines from '@/components/admin/course/ManageDeadlines';
import RemoveUsers from '@/components/admin/course/RemoveUsers';
import CreateTest from '@/components/admin/course/AddTest';

export default {
  name: 'SuperAdminCompanyCourses',
  components: {
    TableThumb,
  },
  data() {
    return {
      headers: [
        { text: 'Published', value: 'published', sortable: false, align: 'center'},
        { text: 'Course', value: 'name' },
        { text: 'Total Users', value: 'total_users', sortable: false },
        { text: 'In Progress', value: 'total_inprogress', sortable: false },
        { text: 'Completed', value: 'total_completed', sortable: false },
        { text: 'Not Started', value: 'total_not_started', sortable: false },
      ],
      courses: [],
      search: '',
      pagination: {},
      options: {},
      loading: false,
      searchParams: '',
      companyId: this.$route.params.id,
      selected: [],
      confirmDelete:
        'Are you sure you want to delete this course? All Course users and associated data will be removed.',
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    hasTest: function () {
      return this.test == null ? false : true;
    },
    test: function () {
      return this.course.hasOwnProperty('test')
        ? this.course.test.data.id
        : null;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getCourses();
      },
      deep: true,
    },
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    createTest(id) {
      testAPI.createTest(id).then((resp) => {
        this.$router.push('/admin/courses/test/' + resp.data.data.id);
      });
    },
    deleteCourse(id) {
      this.$snotify.confirm(this.confirmDelete, {
        backdrop:0.3,                        
        buttons: [
          { text: 'Cancel',className: 'toast-cancel-button' },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processDeleteCourse(toast, id),
          }          
        ],
      });
    },
    processDeleteCourse(toast, id) {
      this.$snotify.remove(toast.id);
      courseAPI.deleteCourse(id).then((response) => {
        this.getCourses();
      });
    },
    editTest(id) {
      this.$router.push('/admin/courses/test/' + id);
    },
    publishCourses() {
      let selected = this.selected.map(function (x) {
        return x.id;
      });
      courseAPI.togglePublish(selected, true).then((resp) => {
        this.getCourses();
      });
    },
    unpublishCourses() {
      let selected = this.selected.map(function (x) {
        return x.id;
      });
      courseAPI.togglePublish(selected, false).then((resp) => {
        this.getCourses();
      });
    },
    applySearch() {
      if (this.search != null) {
        this.searchParams =
          this.params +
          '&search=name:' +
          this.search +
          '&include=thumbnail,test';
      } else {
        this.searchParams = this.params + '&include=thumbnai,testl';
      }
      this.getCourses();
    },
    resetSearch() {
      this.search = '&include=thumbnail,test';
      this.applySearch();
    },
    getCourses() {
      this.loading = true;
      courseAPI
        .getCourses(
          this.params + '&include=thumbnail,test',
          this.searchParams,
          this.companyId
        )
        .then((resp) => {
          this.courses = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    setEventBus() {
      EventBus.$on('COURSES_UPDATED', (payload) => {
        this.params = payload;
        this.getCourses();
      });
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditCourse,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showCreateTestPanel(id) {
      this.$showPanel({
        component: CreateTest,
        props: {
          id: id,
        },
        openOn: 'right',
      });
    },
    showCreatePanel() {
      this.$showPanel({
        component: CreateCourse,
        props: {
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showEnrolPanel(id) {
      this.$showPanel({
        component: EnrolUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showManageDeadlinesPanel(id) {
      this.$showPanel({
        component: ManageDeadlines,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    showRemoveUsersPanel(id) {
      this.$showPanel({
        component: RemoveUsers,
        disableBgClick: true,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
  },
};
</script>
